import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["NO FOLLOWERS", "NO COMPROMISES", "BUILT FOR THE FEW", "YOU AND THE STEEL"];

export const EditorialMarquee = () => (
  <section data-testid="marquee" className="relative py-14 md:py-20 bg-[#050505] border-y border-white/10 overflow-hidden">
    <Marquee speed={38} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="marquee-word text-transparent text-stroke text-6xl md:text-8xl px-8">
            {w}
          </span>
          <span className="marquee-word text-white text-6xl md:text-8xl px-8 opacity-90">
            /
          </span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
